import { useQuery } from "@tanstack/react-query";
import type { Currency } from "../../entities/ledger/types";
import { useActiveBook } from "../books/activeBook";
import { loadDashboard } from "./api";

// One workspace snapshot shared by every page: dashboard, accounts list and
// account detail all read the same book, accounts and balances.
export function useDashboard(currency: Currency) {
  const now = new Date();
  const { bookID } = useActiveBook();
  return useQuery({
    queryKey: ["dashboard", currency, bookID, now.getFullYear(), now.getMonth()],
    queryFn: () => loadDashboard(currency, bookID),
  });
}
